import React from 'react';
import { useNavigate } from 'react-router-dom';

function AccountButton({buttonName, additionalClass}) {
  const navigate = useNavigate();
  return (
    <button
      className={`${additionalClass} account-button`}
      onClick={() => {
        navigate('/profile');
      }}
    >
      {buttonName ? {buttonName} : 'Аккаунт'}
    </button>
  );
}

export default AccountButton;
